import { Model } from "@vuex-orm/core";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default class Powder extends Model {
  static entity = 'powders';

  static $fetch() {
    return this.api().get('Powders/')
  }
  static $get (id) {
    return this.api().get(`Powders/${id}/`)
  }
  static $post (data) {
    return this.api().post(`Powders/`, data)
  }
  static $put (id, data) {
    return this.api().put(`Powders/${id}/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(""),
      icon: this.string("fas fa-shapes"),
      label: this.string("Powder Name"),
      color: this.string("blue-grey darken-2"),
      counter: this.number(64),
      hint: this.string(
        "The name of your powder variety. NCA, Graphite, Extrudate, etc..."
      )
    };
  }

  toCreatePayload() {
    return {
      name: this.name
    };
  }

  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }

  static get validations() {
    return {
      formdata: {
        name: {
          required,
          minLength: minLength(1),
          maxLength: maxLength(64)
        }
      }
    };
  }
}

